define [], () ->
  () ->
    require('./../../../app.scss')
    window.location.replace("https://atproperties.rentapplication.net/quick_forms_display")



// WEBPACK FOOTER //
// ./components/dashboard/quick_forms/quick_forms_display.coffee